import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: ['dataset', 'options'],
  data () {
    return {
    }
  },
  computed: {},
  methods: {
  },
  mounted () {
  },
  watch: {
    dataset () {
      this.$data._chart && this.$data._chart.destroy()

	    this.renderChart({
		    datasets: [this.dataset],
		    labels: [
			    'Orders',
			    'Returns',
			    'Cancellations'
		    ]}, this.options)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/Charts/DoughnutChart.js